module.exports = __webpack_public_path__ + "img/UTGREA-2.5430105f.jpg";